// SportPill — sport-selector pill for ActivityWizard Steg 1 (delspår 3b).
// Reuses SportIcon (Lesson 38) + the SettingsGeneral selected-state convention
// (border-primary bg-primary/5). Non-active sports render disabled/greyed per
// locked beslut #1 (padel-only active; grid is extension-ready).

import { cn } from "@/lib/utils";
import SportIcon from "@/components/SportIcon";

interface SportPillProps {
  sport: string;
  label: string;
  selected: boolean;
  disabled?: boolean;
  onSelect: (sport: string) => void;
}

export default function SportPill({
  sport,
  label,
  selected,
  disabled = false,
  onSelect,
}: SportPillProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      data-testid={`sport-pill-${sport}`}
      onClick={() => onSelect(sport)}
      className={cn(
        // Livfull: soft accent-soft tint on selected (NOT full gradient — that's reserved for the
        // larger type-card surface). Decision locked 2026-06-20.
        "flex flex-col items-center gap-1.5 rounded-[14px] border p-3 text-sm transition-colors",
        selected ? "border-primary bg-primary/10 font-medium" : "border-border",
        disabled ? "cursor-not-allowed opacity-50" : "hover:border-primary/50",
      )}
    >
      <SportIcon sport={sport} size="md" />
      <span className="text-xs">{label}</span>
    </button>
  );
}
